import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(13.75)};
  block-size: ${spacing(10.625)};
`
export default createSvgIcon(
  <svg
    className="footer__icon icon-car"
    fill="none"
    height="85"
    viewBox="0 0 110 85"
    width="110"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="83"
      rx="11"
      stroke="white"
      strokeWidth="2"
      width="108"
      x="1"
      y="1"
    />
    <path
      clipRule="evenodd"
      d="M21.7881 27.641L17 47.6451H45.8893L45.8891 47.6461H17V58.7059C17 63.2866 20.8802 67 25.6667 67C29.4402 67 32.6504 64.692 33.8402 61.4706H55.0487C56.2384 64.6921 59.4486 67 63.2222 67C66.9957 67 70.206 64.692 71.3957 61.4706H78.1598C79.3496 64.692 82.5598 67 86.3333 67C91.1198 67 95 63.2866 95 58.7059C95 50.8861 95 46.9762 92.4616 44.5469C91.0787 43.2235 89.2368 42.6211 86.5252 42.3468L81.6189 32.7196C80.2391 30.0118 77.3666 28.2941 74.2187 28.2941H58.8889V28.2903H66.1111V27.3984C66.1111 25.6615 66.1111 24.793 65.9086 24.0805C65.371 22.1882 63.8253 20.7094 61.848 20.1954C61.1718 20.0196 60.3713 20.0036 58.8889 20.0025V20L31.7981 20.0058C27.8734 20.0066 25.911 20.007 24.5067 21.0781C23.1026 22.1491 22.6644 23.9797 21.7881 27.641ZM58.8889 31.0588V39.4128L81.9792 39.7335L79.0223 33.9315C78.1267 32.1738 76.2622 31.0588 74.2187 31.0588H58.8889ZM69 58.7059C69 61.7597 66.4132 64.2353 63.2222 64.2353C60.0312 64.2353 57.4444 61.7597 57.4444 58.7059C57.4444 55.6521 60.0312 53.1765 63.2222 53.1765C66.4132 53.1765 69 55.6521 69 58.7059ZM31.4444 58.7059C31.4444 61.7597 28.8577 64.2353 25.6667 64.2353C22.4756 64.2353 19.8889 61.7597 19.8889 58.7059C19.8889 55.6521 22.4756 53.1765 25.6667 53.1765C28.8577 53.1765 31.4444 55.6521 31.4444 58.7059Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>,
  'Car',
  {viewBox: '0 0 110 85', className},
)
